import { render, staticRenderFns } from "./addKp.vue?vue&type=template&id=2ab48bdc&scoped=true&"
import script from "./addKp.vue?vue&type=script&lang=js&"
export * from "./addKp.vue?vue&type=script&lang=js&"
import style0 from "./addKp.vue?vue&type=style&index=0&id=2ab48bdc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ab48bdc",
  null
  
)

export default component.exports